import React, { useContext } from 'react';
import { ModifyPlaylistButton } from '@atlassian/ai-audio/ui/buttons';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { PageCardContext } from '../PageCardContext.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';
import { isExperimentEnabled } from '@confluence/feature-experiments';

const WrappedButton = ({ flags, isEndOfPage }) => {
	const { cloudId } = useSessionData();
	const { id, type, title } = useContext(PageCardContext);

	return (
		cloudId &&
		type === 'page' &&
		isExperimentEnabled('confluence_audio_v3') && (
			<ModifyPlaylistButton
				cloudId={cloudId}
				contentId={id}
				contentType={type}
				title={title.text}
				subtle
				flagsOverride={flags}
				actionSource={isEndOfPage ? 'endOfPageRecommendations' : 'pageTree'}
			/>
		)
	);
};

export const AudioPlaylistButton = withFlags(WrappedButton);
